import { css } from '@emotion/react'
import { LabelPosition } from './constants'

// layout

const labelMargin = '5px'

export const flexCenterContent = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const flexCenterContentCrossAxis = css`
  display: flex;
  align-items: center;
`

export const noCollapse = css`
  &:empty:before {
    content: '\200b';
  }
`

export const noWrap = css`
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const deltaLabel = css`
  svg {
    height: 9px;
    width: 9px;
  }
`

// transitions

export const panelTransition = css`
  transition-property: flex;
  transition-duration: 0.4s;
  transition-timing-function: ease;
`

export function getFlexDirection(labelPosition: LabelPosition): string {
  switch (labelPosition) {
    case LabelPosition.Left:
      return 'row-reverse'
    case LabelPosition.Right:
      return 'row'
    case LabelPosition.Top:
      return 'column-reverse'
    case LabelPosition.Bottom:
      return 'column'
    default:
      throw new Error('Unhandled LabelPosition')
  }
}

export const labelLayout = (labelPosition: LabelPosition = LabelPosition.Bottom) => css`
  flex-direction: ${getFlexDirection(labelPosition)};
  ${flexCenterContent};

  label {
    margin-left: ${labelPosition === LabelPosition.Right ? labelMargin : 0};
    margin-right: ${labelPosition === LabelPosition.Left ? labelMargin : 0};
    margin-top: ${labelPosition === LabelPosition.Bottom ? labelMargin : 0};
    margin-bottom: ${labelPosition === LabelPosition.Top ? labelMargin : 0};
  }
`
